module.exports = __webpack_public_path__ + "img/logo.e06e4bf.png";